var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadButtonIconFail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 4,
    fill: "white",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29163 13.2812H5.20829C4.633 13.2812 4.16663 13.7476 4.16663 14.3229V18.4896C4.16663 19.0649 4.633 19.5312 5.20829 19.5312H7.29163C7.86692 19.5312 8.33329 19.0649 8.33329 18.4896V14.3229C8.33329 13.7476 7.86692 13.2812 7.29163 13.2812Z",
    fill: "#FF717D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5416 5.46875H11.4583C10.883 5.46875 10.4166 5.93512 10.4166 6.51042V18.4896C10.4166 19.0649 10.883 19.5312 11.4583 19.5312H13.5416C14.1169 19.5312 14.5833 19.0649 14.5833 18.4896V6.51042C14.5833 5.93512 14.1169 5.46875 13.5416 5.46875Z",
    fill: "#FF4E5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7916 10.1562H17.7083C17.133 10.1562 16.6666 10.6226 16.6666 11.1979V18.4896C16.6666 19.0649 17.133 19.5312 17.7083 19.5312H19.7916C20.3669 19.5312 20.8333 19.0649 20.8333 18.4896V11.1979C20.8333 10.6226 20.3669 10.1562 19.7916 10.1562Z",
    fill: "#FFB8BE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadButtonIconFail);
export default __webpack_public_path__ + "static/media/UploadButtonIconFail.133961a4.svg";
export { ForwardRef as ReactComponent };